var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.23571 0 0 2.30017 0 5.14415C0 8.28208 3.30714 11.6625 4.54286 12.8163C4.80714 13.0588 5.19286 13.0588 5.45714 12.8163C6.69286 11.6625 10 8.28208 10 5.14415C10 2.30017 7.76429 0 5 0ZM5 7.34878C3.81429 7.34878 2.85714 6.36405 2.85714 5.14415C2.85714 3.92425 3.81429 2.93951 5 2.93951C6.18571 2.93951 7.14286 3.92425 7.14286 5.14415C7.14286 6.36405 6.18571 7.34878 5 7.34878Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.5c00a634933a4a880a3c590400c06541.svg";
export { ForwardRef as ReactComponent };